import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {FileFieldEditComponent} from '../../components/Exports/FileFieldEdit.component';


@Component({
  selector: 'my-file-field-grid',
  templateUrl: './FileFieldGrid.component.html'
})
export class FileFieldGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(FileFieldEditComponent) recordEditComponent: FileFieldEditComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    records: ent.FileField[];
    editedRecord: ent.FileField;
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private exportService: serv.ExportService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.editedRecord = new ent.FileField();
        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'ExportField.ID', header: 'ExportField ID' },
            { field: 'ExportField.Header', header: 'Header' },
            { field: 'ExportField.CONAHeader', header: 'CONA Header' },
            { field: 'ExportField.FieldName', header: 'Field Name' },
            { field: 'ExportField.FieldTypeID', header: 'Field Type ID' },
            { field: 'ExportField.FieldType.Name', header: 'Field Type' },
            { field: 'ExportField.Value', header: 'Value' },
            { field: 'ExportFile.ID', header: 'ExportFile ID' },
            { field: 'ExportFile.Name', header: 'File Name' },
            { field: 'Sequence', header: 'Sequence' },
            { field: 'Inactive', header: 'Inactive' },
        ];
    }

    onAddClick(event: any){
        this.editedRecord = new ent.FileField();
        this.recordEditComponent.exportFileDropdownComponent.value = null;
        this.recordEditComponent.exportFieldDropdownComponent.value = null;
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, record: ent.FileField){
        this.editedRecord = record;
        this.recordEditComponent.exportFileDropdownComponent.value = record.FileID;
        this.recordEditComponent.exportFieldDropdownComponent.value = record.FieldID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveFileFieldRequest = {FileField: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.exportService.saveFileField(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        this.recordEditComponent.exportFileDropdownComponent.load();
        this.recordEditComponent.exportFieldDropdownComponent.load();
        this.exportService.getFileFields().subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    
    
}